import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";
import navbarCloseIcon from "../assets/images/navbar-close-icon.svg";
import manageclients from "../assets/images/manageclients.svg";
import requestclientcard from "../assets/images/requestclientcard.svg";
import reportissue from "../assets/images/reportadnissue.svg";
import suggestion from "../assets/images/makeasuggestion.svg";
import testimonial from "../assets/images/testimonial.svg";
import { FiArchive } from "react-icons/fi";

const AttorneyDashBoardSidebar = () => {
  const tabs = [
    {
      label: "Manage Clients",
      link: "/manage-clients",
      img: manageclients,
    },
     {
      label: "Archive Clients",
      link: "/archive-clients",
      icon: FiArchive ,
    },
    {
      label: "Request Client Cards",
      link: "/attoney-card-request",
      img: requestclientcard,
    },
    {
      label: "Report an Issue",
      link: "/attorney-issue-report",
      img: reportissue,
    },
    {
      label: "Make a Suggestion",
      link: "/make-suggestion",
      img: suggestion,
    },
    {
      label: "Leave a Testimonial",
      link: "/leave-testimonial",
      img: testimonial,
    },
    // {
    //   label: "Printable Info Sheets",
    //   link: "/printable-info-sheets",
    //   img: img3,
    // },
  ];

  return (
    <div>
      <nav id="sidebar" aria-label="Attorney navigation">
        <div className="sidebar-header">
          <div className="logo_Wrap">
            <Link className="logo_hover" to={"/"}>
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="navbar_header mb_show_cross">
            <button type="button" id="sidebarCollapse_close" className="close_btn"
             onClick={() => {
              document.getElementById("sidebar").style.marginLeft = "-325px";
            }}>
              <img
                src={navbarCloseIcon}
                alt="navbarCloseIcon"
                className="close_btn"
              />
            </button>
          </div>
        </div>
        <ul className="list-unstyled components adminSidebar attorneySidebar">
          {/* {tabs.map((tab) => (
            <li>
              <NavLink to={tab.link} activeClassName="active">
                {tab.icon ? <span><FiUser /><tab.icon size={20} style={{ marginRight: "10px" }} /></span> : <img src={tab.img} alt="img1" /> }
                {tab.label}
              </NavLink>
            </li>
          ))} */}
          {/* <img src={tab.img} alt="img1" /> {tab.label} */}
          {tabs.map((tab) => (
            <li key={tab.link}>
              <NavLink
                to={tab.link}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {() => (
                  <>
                    {tab.icon ? (
                      <span>
                        <tab.icon
                          size={20}
                          style={{
                            marginRight: "12px",
                            color: "currentColor",
                          }}
                        />
                      </span>
                    ) : (
                      <img src={tab.img} alt="img1" />
                    )}

                    {tab.label}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default AttorneyDashBoardSidebar;
